import { render, staticRenderFns } from "./MarketReportConfigurationItem.vue?vue&type=template&id=d00fbdd6&scoped=true&"
import script from "./MarketReportConfigurationItem.vue?vue&type=script&lang=js&"
export * from "./MarketReportConfigurationItem.vue?vue&type=script&lang=js&"
import style0 from "./MarketReportConfigurationItem.vue?vue&type=style&index=0&id=d00fbdd6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d00fbdd6",
  null
  
)

export default component.exports